<template>
  <div class="three-column-info"
    v-if="
      customFields.three_column_column_1_title || customFields.three_column_column_1_content ||
      customFields.three_column_column_2_title || customFields.three_column_column_2_content ||
      customFields.three_column_column_3_title || customFields.three_column_column_3_content"
  >
    <div class="three-column-info__wrapper">
      <div class="three-column-info__column" v-if="customFields.skin_type && activeColums>=1 ">
        <h3 v-if="customFields.three_column_column_3_title && false" class="h7">{{customFields.three_column_column_3_title	}}</h3>
        <ul class="three-column-info__skin-types" v-if="false">
          <li v-for="(skin_type,index) in customFields.skin_type" :key="`active-${index}`" class="three-column-info__skin-types-item"><strong><icon name="check" size="16px"  class="three-column-info__skin-types-icon"/> <span>{{skin_type.skin_type_options}}</span></strong></li>
          <li v-for="(item,index) in inactiveSkinTypes()" :key="`inActive-${index}`" class="three-column-info__skin-types-item-inactive">
            <span><icon name="check" size="16px" class="three-column-info__skin-types-icon" /> {{ item }}</span></li>
        </ul>
      </div>

      <div class="three-column-info__column" v-if="activeColums>=2 && (customFields.three_column_column_1_title || customFields.three_column_column_1_content)">
        <!-- <h3 v-if="customFields.three_column_column_1_title" class="h7">{{customFields.three_column_column_1_title}}</h3> -->
        <!-- <div v-if="customFields.three_column_column_1_content" class="body-md" v-html="customFields.three_column_column_1_content" /> -->
         <!-- <div class="product-form__detail-icons" >
          <div class="product-form__detail-icon" v-for="(valueProp, i) in valueProps()" :key="i">
            <img class="product-form__detail-icon-icon" :src="valueProp.icon">
            <span class="product-form__detail-icon-title"> {{valueProp.title}}</span>
          </div>
         </div> -->

      </div>
      <div class="three-column-info__column" v-if="activeColums==3 && ( customFields.three_column_column_2_title || customFields.three_column_column_2_content)">
        <h3 v-if="customFields.three_column_column_2_title" class="h7">{{customFields.three_column_column_2_title}}</h3>
        <div v-if="customFields.three_column_column_2_content" class="body-md" v-html="customFields.three_column_column_2_content" />
        <div v-if="customFields.three_column_modal_title || customFields.three_column_modal_content">
          <button class="link link--tertiary" v-on:click="toggleModal">
            <span class="link__content">View All Ingredients</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Icon from '@/scripts/components/basic/Icon';
export default {
  name: "ProductThreeColumnInfo",
  components: {
    Icon
  },
  props: {
    customFields: Object,
    activeColums:{
      type: Number,
      default: 2
    }
  },
  data () {
    return {
      modalActive: false,
      skinTypes: ['Sensitive Skin','Oily Skin','Normal Skin','Dry Skin','Combination Skin']
    };
  },
  methods: {
    toggleModal() {
      // this.modalActive = !this.modalActive;
      // document.body.classList.toggle('overflow-hidden');
    },
    // valueProps() {
    //    let detailIconTitles = this.customFields.title ? this.customFields.title.split('|###|') : [];
    //    let detailIconIcons = this.customFields.icon ? this.customFields.icon.split('|###|') : [];
    //   console.log("detailIconTitles",detailIconTitles);
    //   return detailIconIcons.map((icon, i) => ({
    //     title: (detailIconTitles[i]) ? detailIconTitles[i] : '',
    //     icon: detailIconIcons[i]
    //   }));
    // },
    inactiveSkinTypes() {
      return this.skinTypes.filter( ( el ) => !this.customFields.skin_type.map(v=>v.skin_type_options).includes( el ) );
    }
  }
}
</script>

<style lang="scss">
  .three-column-info {
    // padding: 48px 16px;
    span {
      font-size: 12px;
    }

    @include tablet-up {
    padding: 70px 32px 88px;

    }
    &__wrapper {
      max-width: 1440px;
      margin: 0 auto;
      @include tablet-up {
        display: grid;
        grid-template-columns: 15% 70% 15%;
        grid-column-gap: 20px;
      }
    }

    &__column {
      align-items: center;
      display: flex;
      flex-direction: column;
      // margin-bottom: 48px;

      ul {
        list-style: disc;
        line-height: 30px;
        margin-top: 0px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      @include tablet-up {
        margin-bottom: 0;
      }

      .h7 {
        margin-bottom: 8px;
        @include tablet-up {
          margin-bottom: 18px;
        }
      }

      .body-md {
        color: $color-black-700;
        line-height: rem(23);

        p {
          color: $color-black-700;
          margin-bottom: 10px;
        }

        strong {
          font-weight: 600;
        }

        a {
          color: $color-black-700;
        }
      }
      .link {
        font-family: $font-family-secondary;
        color: $color-black-700;
        font-size: rem(14);
        line-height: rem(22);
      }

      & > * {
        width: 100%;
        max-width: 80%;
      }

    }
    .three-column-info__skin-types{
      padding: 0;
      list-style-type: none;
    }
    .three-column-info__skin-types-item strong{
      font-weight:normal;
    }
    .three-column-info__skin-types-item-inactive{
      opacity:0.4;
    }
    .three-column-info__skin-types-icon{
      vertical-align: middle;
    }

    &__modal {
      height: 100%;
      width:100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: $color-white-tea-300;
      opacity: 0;
      pointer-events: none;
      z-index: 1000;
      transition: all .6s $default-animation-timing;
      display: flex;
      align-items: center;
    }

    &__modal-close {
      position: absolute;
      right: 11px;
      top: -49px;

      @include custom-breakpoint-up(425px) {
        right: -11px;
      }

      @include tablet-up {
        right: -51px;
        top: -100px;
      }
    }

    &__modal-content {
      max-width: 360px;
      max-height: calc(100vh - 220px); // keep close button from being pushed out of view
      padding: 0 16px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      position: relative;

      @include tablet-up {
        max-width: 504px;
        max-height: calc(100vh - 300px); // keep close button from being pushed out of view
      }

      &-rail {
        height: 100%;
        overflow: auto;
      }

      .h6 {
        margin-bottom: 20px;

        @include mobile-only {
          font-size: rem(20);
          line-height: rem(21);
        }
      }

      .body-md {
        color: $color-black-700;
        line-height: rem(23);

        @include mobile-only {
          font-size: rem(14);
          line-height: rem(22);
        }
        p {
          margin-bottom: 30px;
        }

        strong {
          font-weight: 600;
        }
      }
    }

    &__modal--active {
      opacity: 1;
      pointer-events: all;
    }
  }
  .product-form__detail-icons {
    display: flex;
    justify-content: center;
    padding-top: 0px;
    @include tablet-up {
      z-index: 1;
      width: 482px;
    }
  }
  .product-form__detail-icon {
    display: flex;
    flex: 1 0 25%;
    max-width: 25%;
    flex-direction: column;
    text-align: center;
    padding: 0 5px;
  }
  .product-form__detail-icon-icon {
      // height: 24px;
      width: 70px;
      display: inline-block;
      margin: 0 auto;
      margin-bottom: 8px;
  }
</style>
